<template>
    <div class="error">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-7 text-center">
                    <img class="img404" src="@/assets/images/error-404.png" alt="image 404">
                    <h2 class="h2_404"><b>404</b> {{ $t('h2Page404') }}</h2>
                    <p class="p_404">{{ $t('p1Page404') }} <br> {{ $t('p2Page404') }}</p>
                    <router-link to="/">
                        <button class="cmn-btn mt-4">{{ $t('btnToHomePage404') }}</button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .img404 {
        max-width: 100%;
        max-height: 350px;
    }

    .h2_404 {
        font-size: 32px;
    }

    @media (max-width: 991px) {
        .h2_404 {
            font-size: 36px;
        }
    }

    @media (max-width: 575px) {
        .h2_404 {
            font-size: 28px;
        }
    }


    .h2_404 {
        font-family: "Poppins", sans-serif;
        color: #525252;
        font-weight: 600;
        margin: 0;
        line-height: 1.4;
    }

    .h2_404>a {
        font-family: "Poppins", sans-serif;
        color: #525252;
        font-weight: 600;
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
        line-height: 1.4;
    }

    .p_404 {
        margin: 0;
    }

    a {
        text-decoration: none;
        display: inline-block;
        font-family: "Roboto", sans-serif;
        font-weight: 400;
    }

    a:hover {
        text-decoration: none;
    }

    .cmn-btn {
        padding: 12px 35px;
        text-transform: uppercase;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        -ms-border-radius: 5px;
        -o-border-radius: 5px;
        background-color: #6e41ff;
        box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
        color: #ffffff;
    }

    .cmn-btn:hover {
        color: #ffffff;
        background-color: #5b28ff;
    }

    .error {
        position: relative;
    }

    .error .title {
        font-size: 42px;
        margin-top: 30px;
        margin-bottom: 15px;
    }

    @media (max-width: 480px) {
        .error .title {
            font-size: 32px;
        }
    }

    .error .title b {
        font-size: 72px;
        color: #f45570;
    }

    .error p {
        font-size: 18px;
    }
</style>